import { Directive, ElementRef, HostListener } from '@angular/core';

const SKIPPED_SCHEMES = ['mailto:', 'tel:', 'javascript:'];
const CONFIRM_MESSAGE = "You're about to leave the Apprenticeship Portal and visit an external website. Do you want to continue?";

@Directive({
  selector: 'a[href]',
  standalone: false
})
export class ExternalLinkGuardDirective {

  constructor(private el: ElementRef<HTMLAnchorElement>) { }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const anchor = this.el.nativeElement;
    const rawHref = anchor.getAttribute('href');

    if (!rawHref || rawHref.trim() === '' || rawHref.startsWith('#')) {
      return;
    }

    if (SKIPPED_SCHEMES.some(scheme => rawHref.trim().toLowerCase().startsWith(scheme))) {
      return;
    }

    let resolvedUrl: URL;
    try {
      resolvedUrl = new URL(anchor.href, window.location.href);
    } catch {
      return;
    }

    if (resolvedUrl.origin === window.location.origin) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (window.confirm(CONFIRM_MESSAGE)) {
      if (anchor.target) {
        window.open(resolvedUrl.href, anchor.target);
      } else {
        window.location.href = resolvedUrl.href;
      }
    }
  }

}
